/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Preferred_LanguageInputs */

const cs_form_preferred_language = /** @type {(inputs: Form_Preferred_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferovaný jazyk`)
};

const en_form_preferred_language = /** @type {(inputs: Form_Preferred_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred language`)
};

/**
* | output |
* | --- |
* | "Preferred language" |
*
* @param {Form_Preferred_LanguageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_preferred_language = /** @type {((inputs?: Form_Preferred_LanguageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Preferred_LanguageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_preferred_language(inputs)
	return cs_form_preferred_language(inputs)
});